<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>View Grade Category</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{gradeCategoryDescription.campaign_name}}
              <!-- <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
                :searchOn="'campaign'" @event-name="selectCampaign"></CampaignAutocomplete> -->
            </div>

            <span class="text-danger text-sm mt-3" v-show="campaign_required">{{ campaign_required }}
            </span>

          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="name" v-model="gradeCategoryDescription.name" v-validate="'required'"
                data-vv-as="Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{ errors.first("name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="description" v-model="gradeCategoryDescription.description" v-validate="'required'"
                data-vv-as="Fields Description" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('description')">{{
                errors.first("description")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">


              <template>
                <vs-row vs-w="12" class="mt-5">
                  <vs-col class="mb-5" v-for="campaign_grade_list in campaign_grade_lists" vs-lg="2" vs-sm="6"
                    vs-xs="12">
                    <span>{{ campaign_grade_list.grade }}</span>
                    <input class="ml-1" type="checkbox" v-model="gradeCategoryDescription.grades"
                      :value="campaign_grade_list.grade" />
                  </vs-col>
                </vs-row>




              </template>

            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Opportunity:</span>
            </div>
            <input class="ml-4" type="checkbox" v-model="gradeCategoryDescription.is_opportunity" />
            <div>

            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades can be changed by Sales Developer:</span>
            </div>
            <input class="ml-4" type="checkbox" v-model="gradeCategoryDescription.grades_can_be_changes_by_sd" />
            <div>

            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">

            </div>
            <div class="ml-4">
              <vs-button class="mb-2" @click.prevent="submitForm">Submit</vs-button>

            </div>
            <div>

            </div>
          </div>


        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
  },
  data() {
    return {
      gradeCategoryDescription:[],
      gradeCategoryId:null,
      selected_campaign: null,
      selected_campaign_id: null,
      campaign_required: null,
      companySearchComponentKey: 0,
      please_choose_grades: null,
      selected: [],
      abilities: null,
      campaign_grade_lists: [],
      gradeCategoryDescription: {
        name: null,
        description: null,
        grades: [],
        is_opportunity: false,
        campaign_id: null,
        user_id: null
      },
    };
  },
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
    this.gradeCategoryId = this.$route.params.gradeCategoryId;
    this.fetchGradeCategory()
    
  },
  watch: {
  },
  methods: {
    fetchGradeCategory() {
    this.$store
        .dispatch("campaignsManagement/fetchGradeCategory", this.gradeCategoryId)
        .then(res => {
          this.gradeCategoryDescription = JSON.parse(res.data);
          this.gradeCategoryDescription = this.gradeCategoryDescription[0];

          this.gradeCategoryDescription.grades = JSON.parse(this.gradeCategoryDescription.grades)
      


          console.log(this.gradeCategoryDescription.grades)

          this.getCampaignGrades(this.gradeCategoryDescription.campaign_id)
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignGrades(selected_campaign) {
      this.$store
        .dispatch(
          "campaignsManagement/getCampaignGrades",
          selected_campaign
        )
        .then(res => {
          let result = res.data;
          if (result) {
            this.campaign_grade_lists = result;
          }
          console.log(result)
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    selectCampaign() {
      this.please_choose_campaign = null;
      this.selected_campaign = moduleCampaignManagement.state.campaign.datas;
      this.selected_campaign_id = this.selected_campaign[0].id

      // alert(this.selected_campaign_id)
      this.grade_category.campaign_id = this.selected_campaign_id
      this.getCampaignGrades(this.selected_campaign_id)
      this.$refs.CampaignGradeCategory.gridApi.refreshServerSide({purge : true});
      this.getDataSource()
    },
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this


      self.$validator.validateAll().then(result => {
        if (result) {
          self.updateGradeCategory();
        }
      });
    },
    updateGradeCategory() {

      this.gradeCategoryDescription.user_id = this.user_id
      this.gradeCategoryDescription.id = this.gradeCategoryDescription.uuid

      this.$store.dispatch("campaignsManagement/updateGradeCategory", this.gradeCategoryDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Grade Category",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Grade Category",
              text: res.data.message
            });
            this.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
